/** Id da gaveta do menu no celular; o botão do cabeçalho aponta para ele (`aria-controls`). */
export const MOBILE_NAV_ID = 'menu-principal-gaveta'
